import { createContext } from 'react'

const autopltContext = createContext()

export default autopltContext
